<template>
  <el-scrollbar ref="scrollbar" style="height:100%; overflow-x: hidden">
    <el-row class="index_news">
      <div class="index_head">
        <phone_head v-if="width <= 770" />
        <index_head v-else />
      </div>

      <div class="news_main">
        <div class="news_head">
          <span class="head_name">新闻列表</span>
          <span class="head_point head_point1" />
          <span class="head_point" />
          <span class="head_point" />
        </div>

        <div class="main_main">
          <template v-for="(d, i) in news_data">
            <div :key="i" :class="i === 0 ? 'inside inside1' : 'inside'">
              <router-link :to="{path: '/index/newInfo', query: {id: d.id}}">
                <div class="cursor">
                  <div class="inside_head"><span>{{ d.n }}</span></div>
                  <div class="inside_time">{{ d.d }}</div>
                  <div class="inside_content">{{ d.c }}</div>
                </div>
              </router-link>
            </div>
          </template>
        </div>

        <!--分页-->
        <div v-if="page.total_page !== 0" class="pagination">
          <div class="inside">
            <span class="begin un_active" @click="page_begin">首页</span>
            <span class="prev un_active" @click="page_prev">上一页</span>
            <template v-if="page.total_page > 10 && page.show_page_end < page.total_page">
              <template v-for="i in 10">
                <span v-if="i === 1 && page.show_page_begin !== 0 " :key="i" class="page un_active">...</span>
                <span v-else-if="i < 9" :key="i" :class="page.show_page_begin + i === page.current_page ? 'page active' : 'page un_active'" @click="page_click(page.show_page_begin + i)">{{ page.show_page_begin + i }}</span>
                <span v-else-if="i === 9" :key="i" :class="page.show_page_begin + i === page.current_page ? 'page active' : 'page un_active'">...</span>
                <span v-else-if="i > 9" :key="i" :class="page.show_page_begin + i === page.current_page ? 'page active' : 'page un_active'" @click="page_click(page.total_page)">{{ page.total_page }}</span>
              </template>
            </template>
            <template v-for="(d, i) in page.total_page" v-else>
              <!--              <span v-if="i === 1" :key="i" class="page un_active">...</span>-->
              <span :key="i" :class="i === page.current_page ? 'page active' : 'page un_active'" @click="page_click(i + page.show_page_begin)">{{ i + page.show_page_begin }}</span>
            </template>
            <span class="next un_active" @click="page_next">下一页</span>
            <span class="end un_active" @click="page_end">尾页</span>
          </div>
        </div>
      </div>

      <index_bottom />
    </el-row>
  </el-scrollbar>
</template>

<script>
import { get_news_introduction_page } from '@/api/news'

export default {
  name: 'News',
  data() {
    return {
      width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      news_data: [],
      page: {
        total: 0,
        pageSize: 1,
        totalPage: 0,
        show_page_begin: 0,
        show_page_end: 0,
        current_page: 1
      }
    }
  },
  created() {
    this.get_page_data(1)
  },
  methods: {
    get_page_data(page_num) {
      get_news_introduction_page({ pageSize: this.page.page_size, pageNum: page_num }).then(d => {
        const data = d.d
        const l = data.length
        this.news_data.length = l
        for (let i = 0; i < l; i++) {
          this.news_data.splice(i, 1, data[i])
        }

        this.set_page(d)
      })
    },
    page_begin() {
      this.get_page_data(1)
    },
    page_end() {
      this.get_page_data(this.page.total_page)
    },
    page_prev() {
      const p = this.page.current_page
      if (p > 1) {
        this.get_page_data(p + 1)
      }
    },
    page_next() {
      const p = this.page.current_page
      if (p < this.page.total_page) {
        this.get_page_data(p + 1)
      }
    },
    page_click(page_num) {
      this.get_page_data(page_num)
      this.page.current_page = page_num
    },
    set_page(p) {
      this.page.total = Math.floor(p.totalNum)
      this.page.current_page = Math.ceil(p.pageNum)
      const t = Math.ceil(this.page.total / this.page.page_size)
      const n = Math.floor(this.page.current_page - 4)
      const e = Math.floor(this.page.show_page_begin + 9)

      this.page.total_page = t
      this.page.show_page_begin = n > 1 ? n : 1
      if (e < t) {
        this.page.show_page_end = e
      } else {
        this.page.show_page_end = t
      }
    }
  }
}
</script>

<style lang="scss" scoped>
html, body, .index_news, .news_main{
  min-height: 100%;
}

.index_news{
  //background-color: #20232B;
}

.index_head{
  height: 150px;
  //background-color: #41444B;
}

.news_main{
  //background-color: rgba(0,0,0,0.1);
  min-height: calc(100vh - 200px);
  height: auto;
  width: 60%;
  margin: 0 auto 40px;
  min-width: 850px;
  position: relative;

  .news_head{
    //margin-top: 50px;
    display: flex;
    align-items: flex-end;
    padding: 20px 20px;

    .head_name{
      width: 158px;
      height: 60px;
      background-color: #FF5137;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      -webkit-transform: skewX(-15deg);
      -moz-transform: skewX(-15deg);
      -o-transform: skewX(-15deg);
      -ms-transform: skewX(-15deg);
      transform: skewX(-15deg);
      font-size: 16px;
      font-weight: bold;
    }

    .head_point{
      margin-left: 5px;
      width: 5px;
      height: 10px;
      background-color: #FF5137;
      -webkit-transform: skewX(-15deg);
      -moz-transform: skewX(-15deg);
      -o-transform: skewX(-15deg);
      -ms-transform: skewX(-15deg);
      transform: skewX(-15deg);
    }
    .head_point1{
      margin-left: 10px;
    }
  }

  .main_main{
    margin-top: 26px;

    padding-bottom:100px;

    .inside:hover{
      background-size: 100% 100%;
      -webkit-transition: all 0.5s;
      -moz-transition: all 0.5s;
      -o-transition: all 0.5s;
      -ms-transition: all 0.5s;
      transition: all 0.5s;
    }

    .inside{
      padding-top: 40px;
      padding-bottom: 42px;
      border-bottom: 1px solid #525a6d;
      background: url("https://www.g-bits.com/statics/html/images/news/news_bg3.png") no-repeat center center;
      background-size: 0 0;
      -webkit-transition: all 0.5s;
      -moz-transition: all 0.5s;
      -o-transition: all 0.5s;
      -ms-transition: all 0.5s;
      transition: all 0.5s;

      .cursor{
        cursor: pointer;

        .inside_head{
          font-weight: bold;
          font-size: 20px;
          height: 62px;
          line-height: 62px;
          span {
            margin-left: 20px;
            display: inline-block;
            width: 85vw;
            overflow:hidden;
            text-overflow:ellipsis;
            /*white-space:nowrap;*/
            display:-webkit-box;
            -webkit-box-orient:vertical;
            -webkit-line-clamp:2;
          }
        }
        .inside_time{
          text-align: right;
          color: #6a6d73;
          height: 44px;
          line-height: 44px;
          overflow: hidden;
          margin: 40px 30px;
        }
        .inside_content{
          color: #818387;
          overflow: hidden;
          line-height: 32px;
          height: 32px;
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: 85%;
          margin-left: 30px;
        }
      }
    }
    .inside1{
      border-top: 1px solid #525a6d;
    }
  }

  .pagination{
    width: 100%;
    overflow: hidden;
    margin-top: 100px;

    position:absolute;
    bottom:0;
    width:100%;
    height:100px;

    .inside{
      width: 101%;
      height: 63px;
      font-size: 14px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      left: -.5%;

      .begin, .end{
        width: 128px;
      }
      .prev, .next{
        width: 125.5px;
      }
      .page{
        width: 88.5px;
      }
      .un_active, .active{
        height: 50px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        -webkit-transform: skewX(-12deg);
        -moz-transform: skewX(-12deg);
        -o-transform: skewX(-12deg);
        -ms-transform: skewX(-12deg);
        transform: skewX(-12deg);
      }
      .un_active{
        background-color: #373940;
      }
      .active{
        background-color: #FE5C45;
      }
      .un_active:hover{
        background-color: #FE5C45;
      }
    }
  }
}

</style>

